export const PLO_DEFINITIONS = {
    'Electronics and Communications Engineering': {
        'K1': {
            en: 'Demonstrate, recall, and evaluate knowledge of the concepts, facts, principles, and theories of the basic sciences and mathematics',
            ar: 'إظهار واسترجاع وتقييم المعرفة بالمفاهيم والحقائق والمبادئ والنظريات الخاصة بالعلوم الأساسية والرياضيات.'
        },
        'K2': {
            en: 'Exhibit wide knowledge of essential facts, concepts, principles, and theories related to the Electronics And Communication Engineering discipline',
            ar: 'إظهار معرفة واسعة بالحقائق والمفاهيم والمبادئ والنظريات الأساسية المتعلقة بتخصص هندسة الإلكترونيات والاتصالات.'
        },
        'K3': {
            en: 'Comprehensively identify research and inquiry methodologies',
            ar: 'التحديد الشامل لمنهجيات البحث والاستقصاء.'
        },
        'K4': {
            en: 'Exhibit knowledge of recent development in the Electronics and Communication Engineering discipline.',
            ar: 'إظهار المعرفة بالتطورات الحديثة في تخصص هندسة الإلكترونيات والاتصالات.'
        },
        'S1': {
            en: 'Identify, formulate, and solve complex engineering problems using engineering sciences, basic sciences and mathematics principles.',
            ar: 'تحديد وصياغة وحل المشكلات الهندسية المعقدة باستخدام العلوم الهندسية والعلوم الأساسية ومبادئ الرياضيات.'
        },
        'S2': {
            en: 'Apply critical and creative thinking methods to solve real engineering problems professionally and effectively, considering sustainability, political implications, and health and safety issues.',
            ar: 'تطبيق أساليب التفكير النقدي والإبداعي لحل المشكلات الهندسية الواقعية بمهنية وفعالية، مع مراعاة الاستدامة والآثار السياسية وقضايا الصحة والسلامة.'
        },
        'S3': {
            en: 'Develop and conduct experiments, and analyze the measured data',
            ar: 'تطوير وإجراء التجارب وتحليل البيانات المقاسة.'
        },
        'S4': {
            en: 'Design a component, equipment, or system to meet specific requirements in the electronics and communication engineering field considering public health, safety, and welfare, as well as global cultural, social, environmental, and economical factors.',
            ar: 'تصميم مكون أو جهاز أو نظام لتلبية متطلبات محددة في مجال هندسة الإلكترونيات والاتصالات مع مراعاة الصحة العامة والسلامة والرفاهية، بالإضافة إلى العوامل الثقافية والاجتماعية والبيئية والاقتصادية العالمية.'
        },
        'S5': {
            en: 'Use the techniques, skills, and modern engineering tools necessary for electronics and communications engineering practices',
            ar: 'استخدام التقنيات والمهارات والأدوات الهندسية الحديثة الضرورية لممارسات هندسة الإلكترونيات والاتصالات.'
        },
        'S6': {
            en: 'Convey ideas convincingly, in written and oral form',
            ar: 'إيصال الأفكار بشكل مقنع، كتابياً وشفهياً.'
        },
        'S7': {
            en: 'Conduct inquiries, investigations, and research for complex issues and problems.',
            ar: 'إجراء الاستقصاءات والتحقيقات والبحوث للقضايا والمشكلات المعقدة.'
        },
        'S8': {
            en: 'Apply modern project management, economic and decision-making techniques.',
            ar: 'تطبيق تقنيات إدارة المشاريع الحديثة والاقتصاد واتخاذ القرار.'
        },
        'V1': {
            en: 'Recognize the need for, and an ability to engage in lifelong learning',
            ar: 'إدراك الحاجة إلى القدرة على الانخراط في التعلم مدى الحياة.'
        },
        'V2': {
            en: 'Properly consider professional and ethical responsibility',
            ar: 'المراعاة السليمة للمسؤولية المهنية والأخلاقية.'
        },
        'V3': {
            en: 'Work effectively as a leader/member of a teamwork',
            ar: 'العمل بفعالية كقائد أو عضو في فريق عمل.'
        },
        'V4': {
            en: 'Serve the community through activities in electronics and communication engineering',
            ar: 'خدمة المجتمع من خلال أنشطة في هندسة الإلكترونيات والاتصالات.'
        }
    },
    'Artificial Intelligence': {
        'K1': {
            en: 'Demonstrate, recall, and evaluate knowledge of the concepts, facts, principles, and theories of the basic sciences and mathematics',
            ar: 'إظهار واسترجاع وتقييم المعرفة بالمفاهيم والحقائق والمبادئ والنظريات الخاصة بالعلوم الأساسية والرياضيات.'
        },
        'K2': {
            en: 'Exhibit wide knowledge of essential facts, concepts, principles, and theories related to the Artificial Intelligence (AI) discipline',
            ar: 'إظهار معرفة واسعة بالحقائق والمفاهيم والمبادئ والنظريات الأساسية المتعلقة بتخصص الذكاء الاصطناعي (AI).'
        },
        'K3': {
            en: 'Comprehensively identify research and inquiry methodologies in the field of Artificial Intelligence (AI)',
            ar: 'التحديد الشامل لمنهجيات البحث والاستقصاء في مجال الذكاء الاصطناعي (AI).'
        },
        'K4': {
            en: 'Exhibit wide knowledge of recent development in the Artificial Intelligence (AI)',
            ar: 'إظهار معرفة واسعة بالتطورات الحديثة في الذكاء الاصطناعي (AI).'
        },
        'S1': {
            en: 'Identify requirements and criteria of formulating the problems, and setting the rules of solutions',
            ar: 'تحديد المتطلبات والمعايير لصياغة المشكلات ووضع قواعد الحلول.'
        },
        'S2': {
            en: 'Apply critical and creative thinking methods to solve Artificial Intelligence (AI) and related problems',
            ar: 'تطبيق أساليب التفكير النقدي والإبداعي لحل مشكلات الذكاء الاصطناعي (AI) والمشكلات ذات الصلة.'
        },
        'S3': {
            en: 'Design, implement and analyze software and hardware systems',
            ar: 'تصميم وتنفيذ وتحليل برمجيات وأنظمة العتاد (Hardware).'
        },
        'S4': {
            en: 'Develop and conduct experiments, and analyze the measured data',
            ar: 'تطوير وإجراء التجارب وتحليل البيانات المقاسة.'
        },
        'S5': {
            en: 'Use techniques, skills and modern tools necessary for Artificial Intelligence (AI) practices',
            ar: 'استخدام التقنيات والمهارات والأدوات الحديثة الضرورية لممارسات الذكاء الاصطناعي (AI).'
        },
        'S6': {
            en: 'Express and document ideas and solutions persuasively',
            ar: 'التعبير عن الأفكار والحلول وتوثيقها بشكل مقنع.'
        },
        'S7': {
            en: 'Conduct inquiries, investigations, and research methodologies to solve complex issues and problems',
            ar: 'إجراء الاستقصاءات والتحقيقات ومنهجيات البحث لحل القضايا والمشكلات المعقدة.'
        },
        'V1': {
            en: 'Recognize the need for, and an ability to engage in lifelong learning and continuing professional development',
            ar: 'إدراك الحاجة إلى القدرة على الانخراط في التعلم مدى الحياة والتطوير المهني المستمر.'
        },
        'V2': {
            en: 'Properly consider professional and ethical responsibility',
            ar: 'المراعاة السليمة للمسؤولية المهنية والأخلاقية.'
        },
        'V3': {
            en: 'Work effectively as a leader/member of a teamwork',
            ar: 'العمل بفعالية كقائد أو عضو في فريق عمل.'
        },
        'V4': {
            en: 'Contribute to community activities related to Artificial Intelligence (AI)',
            ar: 'المساهمة في الأنشطة المجتمعية المتعلقة بالذكاء الاصطناعي (AI).'
        }
    },
    'Computer Engineering': {
        'K1': {
            en: 'Demonstrate, recall and evaluate knowledge of the concepts, facts, principles, and theories of the basic sciences and mathematics',
            ar: 'إظهار واسترجاع وتقييم المعرفة بالمفاهيم والحقائق والمبادئ والنظريات الخاصة بالعلوم الأساسية والرياضيات.'
        },
        'K2': {
            en: 'Exhibit wide knowledge of essential facts, concepts, principles, and theories related to the computer and network engineering discipline',
            ar: 'إظهار معرفة واسعة بالحقائق والمفاهيم والمبادئ والنظريات الأساسية المتعلقة بتخصص هندسة الحاسب والشبكات.'
        },
        'K3': {
            en: 'Comprehensively identify research and inquiry methodologies',
            ar: 'التحديد الشامل لمنهجيات البحث والاستقصاء.'
        },
        'K4': {
            en: 'demonstrate knowledge of recent development in the computer engineering field.',
            ar: 'إظهار المعرفة بالتطورات الحديثة في مجال هندسة الحاسب.'
        },
        'S1': {
            en: 'Identify requirements and criteria of formulating the problems, and setting the rules of solutions',
            ar: 'تحديد المتطلبات والمعايير لصياغة المشكلات ووضع قواعد الحلول.'
        },
        'S2': {
            en: 'Apply critical and creative thinking methods to solve problems',
            ar: 'تطبيق أساليب التفكير النقدي والإبداعي لحل المشكلات.'
        },
        'S3': {
            en: 'Develop laboratory sets and conduct experiments, and analyze the measured data',
            ar: 'تطوير المجموعات المعملية وإجراء التجارب وتحليل البيانات المقاسة.'
        },
        'S4': {
            en: 'Design, implement and analyze software and hardware computer and Network engineering systems',
            ar: 'تصميم وتنفيذ وتحليل برمجيات وأنظمة هندسة الحاسب والشبكات.'
        },
        'S5': {
            en: 'Utilize techniques, skills and modern tools necessary for computer engineering practices',
            ar: 'استخدام التقنيات والمهارات والأدوات الحديثة الضرورية لممارسات هندسة الحاسب.'
        },
        'S6': {
            en: 'Communicate effectively in written and oral form with various level audiences',
            ar: 'التواصل الفعال كتابياً وشفهياً مع مختلف فئات الجمهور.'
        },
        'S7': {
            en: 'Perform inquiries, investigations, and research to address complex issues and problems.',
            ar: 'إجراء الاستقصاءات والتحقيقات والبحوث لمعالجة القضايا والمشكلات المعقدة.'
        },
        'S8': {
            en: 'Apply modern project management, economic and decision-making techniques.',
            ar: 'تطبيق تقنيات إدارة المشاريع الحديثة والاقتصاد واتخاذ القرار.'
        },
        'V1': {
            en: 'Recognize the need for, and an ability to engage in lifelong learning',
            ar: 'إدراك الحاجة إلى القدرة على الانخراط في التعلم مدى الحياة.'
        },
        'V2': {
            en: 'Properly consider professional and ethical responsibility',
            ar: 'المراعاة السليمة للمسؤولية المهنية والأخلاقية.'
        },
        'V3': {
            en: 'Work effectively as a leader/member of a teamwork',
            ar: 'العمل بفعالية كقائد أو عضو في فريق عمل.'
        },
        'V4': {
            en: 'Contribute to community activities related to computer and Network engineering',
            ar: 'المساهمة في الأنشطة المجتمعية المتعلقة بهندسة الحاسب والشبكات.'
        }
    },
    'Computer Science': {
        'K1': {
            en: 'Demonstrate, recall and evaluate knowledge of the concepts, facts, principles, and theories of the basic sciences and mathematics',
            ar: 'إظهار واسترجاع وتقييم المعرفة بالمفاهيم والحقائق والمبادئ والنظريات الخاصة بالعلوم الأساسية والرياضيات.'
        },
        'K2': {
            en: 'Exhibit wide knowledge of essential facts, concepts, principles, and theories related to the computer science discipline',
            ar: 'إظهار معرفة واسعة بالحقائق والمفاهيم والمبادئ والنظريات الأساسية المتعلقة بتخصص علوم الحاسب.'
        },
        'K3': {
            en: 'Comprehensively identify research and inquiry methodologies in the field of computer science',
            ar: 'التحديد الشامل لمنهجيات البحث والاستقصاء في مجال علوم الحاسب.'
        },
        'K4': {
            en: 'Exhibit wide knowledge of recent development in the computer science',
            ar: 'إظهار معرفة واسعة بالتطورات الحديثة في علوم الحاسب.'
        },
        'S1': {
            en: 'Identify requirements and criteria of formulating the problems, and setting the rules of solutions',
            ar: 'تحديد المتطلبات والمعايير لصياغة المشكلات ووضع قواعد الحلول.'
        },
        'S2': {
            en: 'Apply critical and creative thinking methods to solve computer science and related problems',
            ar: 'تطبيق أساليب التفكير النقدي والإبداعي لحل مشكلات علوم الحاسب والمشكلات ذات الصلة.'
        },
        'S3': {
            en: 'Develop and conduct experiments, and analyze the measured data',
            ar: 'تطوير وإجراء التجارب وتحليل البيانات المقاسة.'
        },
        'S4': {
            en: 'Design, implement, configure, manage and analyze software and hardware systems',
            ar: 'تصميم وتنفيذ وتكوين وإدارة وتحليل الأنظمة البرمجية والعتادية.'
        },
        'S5': {
            en: 'Use techniques, skills and modern tools necessary for computing practices',
            ar: 'استخدام التقنيات والمهارات والأدوات الحديثة الضرورية لممارسات الحوسبة.'
        },
        'S6': {
            en: 'Express and document ideas and solutions persuasively',
            ar: 'التعبير عن الأفكار والحلول وتوثيقها بشكل مقنع.'
        },
        'V1': {
            en: 'Recognize the need for, and an ability to engage in lifelong learning',
            ar: 'إدراك الحاجة إلى القدرة على الانخراط في التعلم مدى الحياة.'
        },
        'V2': {
            en: 'Properly consider professional and ethical responsibility',
            ar: 'المراعاة السليمة للمسؤولية المهنية والأخلاقية.'
        },
        'V3': {
            en: 'Examine Contemporary challenges and safeguarding information',
            ar: 'فحص التحديات المعاصرة وحماية المعلومات.'
        },
        'V4': {
            en: 'Work effectively as a leader/member of a team-work',
            ar: 'العمل بفعالية كقائد أو عضو في فريق عمل.'
        },
        'V5': {
            en: 'Effectively participate in delivering computer science activities to the society',
            ar: 'المشاركة الفعالة في تقديم أنشطة علوم الحاسب للمجتمع.'
        }
    },
    'Cybersecurity': {
        'K1': {
            en: 'Demonstrate, recall and evaluate knowledge of the concepts, facts, principles, and theories of the basic sciences and mathematics',
            ar: 'إظهار واسترجاع وتقييم المعرفة بالمفاهيم والحقائق والمبادئ والنظريات الخاصة بالعلوم الأساسية والرياضيات.'
        },
        'K2': {
            en: 'Exhibit wide knowledge of essential facts, concepts, principles, and theories related to the cyber security discipline',
            ar: 'إظهار معرفة واسعة بالحقائق والمفاهيم والمبادئ والنظريات الأساسية المتعلقة بتخصص الأمن السيبراني.'
        },
        'K3': {
            en: 'Comprehensively identify research and inquiry methodologies in the field of cyber security',
            ar: 'التحديد الشامل لمنهجيات البحث والاستقصاء في مجال الأمن السيبراني.'
        },
        'K4': {
            en: 'Exhibit wide knowledge of recent development in the cyber security',
            ar: 'إظهار معرفة واسعة بالتطورات الحديثة في الأمن السيبراني.'
        },
        'S1': {
            en: 'Identify, formulate and solve various problems using cyber security sciences, basic sciences and mathematics principles',
            ar: 'تحديد وصياغة وحل المشكلات المتنوعة باستخدام علوم الأمن السيبراني والعلوم الأساسية ومبادئ الرياضيات.'
        },
        'S2': {
            en: 'Apply critical and creative thinking methods to solve cyber security problems',
            ar: 'تطبيق أساليب التفكير النقدي والإبداعي لحل مشكلات الأمن السيبراني.'
        },
        'S3': {
            en: 'Develop and conduct experiments, and analyze the measured data',
            ar: 'تطوير وإجراء التجارب وتحليل البيانات المقاسة.'
        },
        'S4': {
            en: 'Design, implement, configure, manage and analyze software and hardware systems',
            ar: 'تصميم وتنفيذ وتكوين وإدارة وتحليل الأنظمة البرمجية والعتادية.'
        },
        'S5': {
            en: 'Use techniques, skills and modern tools necessary for cyber security practices',
            ar: 'استخدام التقنيات والمهارات والأدوات الحديثة الضرورية لممارسات الأمن السيبراني.'
        },
        'S6': {
            en: 'Express and document ideas and solutions persuasively',
            ar: 'التعبير عن الأفكار والحلول وتوثيقها بشكل مقنع.'
        },
        'V1': {
            en: 'Recognize the need for, and an ability to engage in lifelong learning',
            ar: 'إدراك الحاجة إلى القدرة على الانخراط في التعلم مدى الحياة.'
        },
        'V2': {
            en: 'Properly consider professional and ethical responsibility',
            ar: 'المراعاة السليمة للمسؤولية المهنية والأخلاقية.'
        },
        'V3': {
            en: 'Work effectively as a leader/member of a team-work',
            ar: 'العمل بفعالية كقائد أو عضو في فريق عمل.'
        },
        'V4': {
            en: 'Effectively participate in delivering cyber security activities to the society',
            ar: 'المشاركة الفعالة في تقديم أنشطة الأمن السيبراني للمجتمع.'
        }
    },
    'Industrial Engineering': {
        'K1': {
            en: 'Demonstrate, recall and evaluate knowledge of the concepts, facts, principles, and theories of the basic sciences and mathematics',
            ar: 'إظهار واسترجاع وتقييم المعرفة بالمفاهيم والحقائق والمبادئ والنظريات الخاصة بالعلوم الأساسية والرياضيات.'
        },
        'K2': {
            en: 'Exhibit wide knowledge of essential facts, concepts, principles, and theories related to the industrial engineering discipline',
            ar: 'إظهار معرفة واسعة بالحقائق والمفاهيم والمبادئ والنظريات الأساسية المتعلقة بتخصص الهندسة الصناعية.'
        },
        'K3': {
            en: 'Comprehensively identify research and inquiry methodologies',
            ar: 'التحديد الشامل لمنهجيات البحث والاستقصاء.'
        },
        'K4': {
            en: 'Exhibit knowledge of recent developments in the industrial engineering discipline.',
            ar: 'إظهار المعرفة بالتطورات الحديثة في تخصص الهندسة الصناعية.'
        },
        'S1': {
            en: 'Identify, formulate and solve complex engineering problems using engineering sciences, basic sciences and mathematics principles.',
            ar: 'تحديد وصياغة وحل المشكلات الهندسية المعقدة باستخدام العلوم الهندسية والعلوم الأساسية ومبادئ الرياضيات.'
        },
        'S2': {
            en: 'Apply critical and creative thinking methods to professionally solve real engineering problems, considering sustainability, politics, health, and safety issues.',
            ar: 'تطبيق أساليب التفكير النقدي والإبداعي لحل المشكلات الهندسية الواقعية بمهنية، مع مراعاة الاستدامة والسياسة والصحة وقضايا السلامة.'
        },
        'S3': {
            en: 'Develop and conduct experiments, and analyze the measured data',
            ar: 'تطوير وإجراء التجارب وتحليل البيانات المقاسة.'
        },
        'S4': {
            en: 'Design a component, equipment or system to meet specific requirements in the industrial engineering field considering public health, safety, and welfare, as well as global cultural, social, environmental, and economic factors.',
            ar: 'تصميم مكون أو جهاز أو نظام لتلبية متطلبات محددة في مجال الهندسة الصناعية مع مراعاة الصحة العامة والسلامة والرفاهية، بالإضافة إلى العوامل الثقافية والاجتماعية والبيئية والاقتصادية العالمية.'
        },
        'S5': {
            en: 'Use the techniques, skills, and modern engineering tools necessary for industrial engineering practices',
            ar: 'استخدام التقنيات والمهارات والأدوات الهندسية الحديثة الضرورية لممارسات الهندسة الصناعية.'
        },
        'S6': {
            en: 'Communicate and present ideas clearly, in written and oral form',
            ar: 'التواصل وعرض الأفكار بوضوح، كتابياً وشفهياً.'
        },
        'S7': {
            en: 'Conduct inquiries, investigations, and research for complex issues and problems.',
            ar: 'إجراء الاستقصاءات والتحقيقات والبحوث للقضايا والمشكلات المعقدة.'
        },
        'S8': {
            en: 'Apply modern project management, economic and decision-making techniques.',
            ar: 'تطبيق تقنيات إدارة المشاريع الحديثة والاقتصاد واتخاذ القرار.'
        },
        'V1': {
            en: 'Recognize the need for, and an ability to engage in lifelong learning',
            ar: 'إدراك الحاجة إلى القدرة على الانخراط في التعلم مدى الحياة.'
        },
        'V2': {
            en: 'Properly consider professional and ethical responsibility',
            ar: 'المراعاة السليمة للمسؤولية المهنية والأخلاقية.'
        },
        'V3': {
            en: 'Work effectively as a leader/member of a teamwork',
            ar: 'العمل بفعالية كقائد أو عضو في فريق عمل.'
        },
        'V4': {
            en: 'Contribute to the society services related to the industrial engineering',
            ar: 'المساهمة في الخدمات المجتمعية المتعلقة بالهندسة الصناعية.'
        }
    }
};
